"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncSafeInvoke = exports.safeInvoke = void 0;
const tslib_1 = require("tslib");
const asyncSafeInvoke = (fn, errCallback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let result = null;
    let error = null;
    try {
        result = (yield fn());
    }
    catch (e) {
        error = e;
        yield (errCallback === null || errCallback === void 0 ? void 0 : errCallback(e));
    }
    return { result: result, error };
});
exports.asyncSafeInvoke = asyncSafeInvoke;
const safeInvoke = (fn, errCallback) => {
    let result = null;
    let error = null;
    try {
        result = fn();
    }
    catch (e) {
        error = e;
        errCallback === null || errCallback === void 0 ? void 0 : errCallback(e);
    }
    return { result: result, error };
};
exports.safeInvoke = safeInvoke;
//# sourceMappingURL=safeInvoke.js.map